import './App.scss';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LoginScreen from './modules/auth/screens/login.screen';
import ProtectedRoute from './modules/auth/screens/protected-route.screen';
import { useAuthStore } from './modules/auth/states/auth.state';
import { useEffect } from 'react';
import HomeLayout from './modules/home/screens/home.screen';
import { ToastContainer } from 'react-toastify';
import AxiosInterceptorNavigate from './modules/auth/screens/axios-interceptor.screen';
import { useDashboardStore } from './modules/dashboard/states/dashboard.state';

function App() {

  const { checkAuth } = useAuthStore();
  const { setSelectedDisasterBoot } = useDashboardStore();

  useEffect(() => {
    setSelectedDisasterBoot();
    checkAuth();
  }, []);
  
  return (
    <>
      <BrowserRouter>
        {<AxiosInterceptorNavigate/>}
        <Routes>
          <Route path="/login" element={<LoginScreen />} />
          <Route element={<ProtectedRoute />}>
            <Route path="/" element={<HomeLayout />} />
            <Route path="/home/*" element={<HomeLayout />} />
            <Route
              path="*"
              element={
                <main style={{ padding: "1rem" }}>
                  <p>There's nothing here!</p>
                </main>
              }
            />
          </Route>
        </Routes>
      </BrowserRouter>
      <ToastContainer />
    </>
  );
}

export default App;

